import React from "react";
import { Box, Typography, Grid, TextField, Paper } from "@mui/material";
import { Controller } from "react-hook-form";
import { isMobile } from "react-device-detect";

const ServiceWithDetailsComponent = ({ control, errors }) => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          تفاصيل الطلب
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{ 
          p: 3, 
          borderRadius: "12px",
          border: "1px solid #e0e0e0"
        }}
      >
        <Grid spacing={3} container>
          <Grid item xs={12}>
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>
              التفاصيل <span style={{ color: "red" }}>*</span>
            </Typography>
            <Controller
              name="serviceDetails"
              control={control}
              defaultValue=""
              rules={{
                required: "التفاصيل مطلوبة",
                maxLength: {
                  value: 1000,
                  message: "التفاصيل لا يمكن أن تتجاوز 1000 حرف"
                }
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  multiline
                  minRows={4}
                  maxRows={10}
                  variant="outlined"
                  placeholder="تفاصيل الطلب"
                  error={!!errors.serviceDetails}
                  helperText={
                    errors.serviceDetails 
                      ? errors.serviceDetails.message 
                      : ""
                  }
                  FormHelperTextProps={{
                    sx: {
                      textAlign: "start",
                    },
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>
              العنوان <span style={{ color: "red" }}>*</span>
            </Typography>
            <Controller
              name="serviceTitle"
              control={control}
              defaultValue=""
              rules={{
                required: "العنوان مطلوب",
                maxLength: {
                  value: 200,
                  message: "العنوان لا يمكن أن يتجاوز 200 حرف"
                }
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="outlined"
                  placeholder="عنوان الطلب"
                  error={!!errors.serviceTitle}
                  helperText={
                    errors.serviceTitle 
                      ? errors.serviceTitle.message 
                      : ""
                  }
                  FormHelperTextProps={{
                    sx: {
                      textAlign: "start",
                    },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default ServiceWithDetailsComponent;
